import Box from '@mui/material/Box';
import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { FormSection } from 'common/components/FormSection';
import { Switch } from 'common/components/FormField';

import { TOrganisationSettingsFormValues } from './OrganisationSettingsForm';

export const FeaturesForm = () => {
    const [translate] = useTranslation();
    const { values } = useFormikContext<TOrganisationSettingsFormValues>();

    return (
        <FormSection
            description={
                <Box>
                    {translate('academySettingsForm.featuresDescription')}
                </Box>
            }
            title={translate('academySettingsForm.featuresTitle')}
        >
            <Box sx={{ mt: 1 }}>
                <Field
                    checked={values.showOffers}
                    component={Switch}
                    formControlProps={{ margin: 'none' }}
                    label={translate('academySettingsForm.showOffers')}
                    name="showOffers"
                />

                <Field
                    checked={values.showPortfolio}
                    component={Switch}
                    formControlProps={{ margin: 'none' }}
                    label={translate('academySettingsForm.showPortfolio')}
                    name="showPortfolio"
                />

                <Field
                    checked={values.showLibrary}
                    component={Switch}
                    formControlProps={{ margin: 'none' }}
                    label={translate('academySettingsForm.showLibrary')}
                    name="showLibrary"
                />

                <Field
                    checked={values.showSkills}
                    component={Switch}
                    formControlProps={{ margin: 'none' }}
                    label={translate('academySettingsForm.showSkills')}
                    name="showSkills"
                />

                <Field
                    checked={values.showChat}
                    component={Switch}
                    formControlProps={{ margin: 'none' }}
                    label={translate('academySettingsForm.showChat')}
                    name="showChat"
                />
            </Box>
        </FormSection>
    );
};
